<script>
// import crypto from "crypto";

import request from "./request.vue";
import session from "./session.vue";
import { format } from "date-fns";

// const hashPassword = (rawPassword) => {
// 	const staticSalt = "EspressoSalt000";
// 	let hash = crypto.createHmac('sha256', rawPassword);
// 	for (var i = 0; i < 1024; i++) {
// 		hash.update(staticSalt + rawPassword);
// 	}
// 	return hash.digest("hex");
// }

const userSchema = [
	{
		name: "id",
		displayName: "Código",
		kind: "text",
		validation: "",
		placeholder: "Digite o código do usuário",
		defaultSort: true,
		readOnly: true,
		search: {
			show: false,
			endWildcard: true,
			startWildcard: true,
		},
	},
	{
		name: "creationDate",
		displayName: "Data do cadastro",
		kind: "text",
		validation: "",
		placeholder: "",
		readOnly: true,
		formatter: value => format(value, "DD/MM/YYYY HH:mm"),
		creationHidden: true,
	},
	{
		name: "name",
		displayName: "Nome",
		kind: "text",
		validation: "required",
		placeholder: "Digite o nome",
		defaultSort: true,
		notInFilters: false,
		search: {
			show: true,
			endWildcard: true,
			startWildcard: true,
		},
	},
	{
		name: "email",
		displayName: "Email",
		kind: "text",
		validation: "",
		notInFilters: true,
		placeholder: "Digite o email",
		search: {
			show: true,
			endWildcard: true,
			startWildcard: true,
		},
	},
	{
		name: "companyName",
		displayName: "Empresa",
		kind: "text",
		validation: "",
		placeholder: "Digite o código do usuário",
		defaultSort: true,
		readOnly: true,
		creationHidden: true,
		notInFilters: true,
		search: {
			show: true,
			endWildcard: true,
			startWildcard: true,
		},
	},
	{
		name: "lastLogin",
		displayName: "Último acesso",
		kind: "text",
		validation: "",
		placeholder: "",
		readOnly: true,
		formatter: value => format(value, "DD/MM/YYYY HH:mm"),
		creationHidden: true,
	},
	{
		name: "rawPassword",
		displayName: "Senha",
		kind: "password",
		validation: "",
		creationOnly: true,
	},
];

export default {
	create: async function (userInfo) {
		userInfo.role = "TEMPORARY";

		if (userInfo.rawPassword) {
			// userInfo.password = hashPassword(userInfo.rawPassword);
			userInfo.password = userInfo.rawPassword;
			delete userInfo.rawPassword;
		}

		let response = await request.send("user", "create", userInfo, true);
		return response.data;
	},
	login: async function (email, rawPassword) {
		let passwordHash = rawPassword;
		let sessionData = await request.send("user", "login", {
			email: email,
			password: passwordHash
		});

		// Maybe we have to change the admin to login with special endpoint
		if (!["ADMIN", "SPECIALIST"].includes(sessionData.userInfo.role)) throw Error("ERR_API_INCORRECT_EMAIL_OR_PASSWORD");

		await session.setSessionData({ token: sessionData.token, ...sessionData.userInfo });

		return sessionData.success;
	},
	loginSendPin: async function (data) {
		console.log('logD call src/api/login.vue(data) ', data)
		let sessionData = await request.send("user", "send-pin", data);
		// await session.setSessionData(sessionData);
		// console.log('sessionData -> ', sessionData)
		return sessionData;
	},
	verifyPin: async function (data) {
		// console.log('call src/api/login.vue(data) ', data)
		// await session.setSessionData(sessionData);
		const pin = await request.send("user", "login-by-email-pin", data);
		// console.log('sessionData -> ', sessionData)
		return pin;
	},
	logout: async function () {
		try {
			await request.send("user", "logout", {}, true);
		} catch (error) {
			console.log(error)
		}

		await session.clear();
	},
	getInfo: async function (id) {
		const response = await request.send("user", "getInfo", { id }, true);
		return response.data;
	},
	updateInfo: async function (userData) {
		const response = await request.send("user", "updateInfo", userData, true);
		return response.data;
	},
	// swipeStatus: async function(technicianId, value) {
	// 	let status = "";

	// 	value ? status = "APPROVED" : status = "SUSPENDED";

	// 	const response = await request.send("user", "updateTechnicianStatus", { technicianId, status }, true);

	// 	return response.success;
	// },
	// importCsv: async function(csv) {
	// 	return request.send("user", "importCsv", { csv }, true);
	// },
	changePassword: async function (email, newPassword) {
		// let passwordHash = hashPassword(newPassword);
		let passwordHash = newPassword;
		let response = await request.send("user", "changePassword", {
			userEmail: email,
			newPassword: passwordHash
		}, true);
		return response.success;
	},
	// remove: async function (id) {
	// 	return request.send("user", "updateInfo", {
	// 		id,
	// 		status: "BANNED",
	// 	}, true);
	// },
	remove: async function (id) {
		return request.send("user", "delete", { id }, true);
	},
	search: async function (parameters) {
		const response = await request.send("user", "search", parameters, true);
		return response;
	},
	getSchema: function () {
		return userSchema;
	},
	lgpdAnonimize: async function (data) {
		return request.send("user", "lgpd/update", data, true)
	},
}
</script>
